import { Route } from 'react-router';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { ActiveCareMapProviderV2 } from '../ActiveCareMapProvider';
import { ShowCheckin } from './ShowCheckin';
import { JournalPage } from './JournalPage';
import { CareMapState } from '../caremap/CareMapState';

export const JournalRouteHandler: React.FC = () => {

    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    return (
        <Route path="/calendar/journal">
            <ActiveCareMapProviderV2 careMapId={careMapState.getMostRecentCaremap()?.careMapId}>
                <JournalPage />
                <Route exact path="/calendar/journal/daily-log">
                    <ShowCheckin />
                </Route>
            </ActiveCareMapProviderV2>
        </Route>
    );
};
